import { render, staticRenderFns } from "./orgtree.vue?vue&type=template&id=9485e914&scoped=true"
import script from "./orgtree.vue?vue&type=script&lang=js"
export * from "./orgtree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9485e914",
  null
  
)

export default component.exports